import React from 'react';
import Modal from 'react-bootstrap/Modal';

export const AttachmentModal = ({ showLoadingAttachment }) => {
  return (
    <div>
      {showLoadingAttachment && (
        <Modal className="attachmentModal" show={showLoadingAttachment}>
          <Modal.Body>
            <Modal.Title>
              <div className="loaderAreaDropzone">
                <img
                  src={'https://tgcrm.net/public/assets/images/cxm-loader.webp'}
                  alt="loader"
                  style={{ width: '48px' }}
                  className="zmdi-hc-spin"
                />
                <span className="loaderText">Attachment Uploading...</span>
              </div>
            </Modal.Title>
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
};
